import React from 'react';
import { Layout, Row, Col, Checkbox, Button, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../Navbar.js';
import questions from './surveyList.js';
import "../../Components/App.css";
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedAnswers } from '../../redux/actions/selctedSurveyAction.js';
import Footer from '../footerComponent/Footer.js';
import "./Survey.css";
import SurveyInfo from "../SurveyInfo/SurveyInfo.js";

const { Content } = Layout;

const QuestionsPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const selectedAnswers = useSelector((state) => state.selectedSurvey.selectedAnswers);
  const accessibleApplications = useSelector((state) => state.landingPage.accessibleApplications);

  // Services with translation mapping for each language
  const applicationTranslations = {
    'Windchill application': {
      English: 'Windchill application',
      Japanese: 'Windchillアプリケーション',
    },
    'Planisware': {
      English: 'Planisware',
      Japanese: 'Planisware',
    },
    'Conga (Apttus) CPQ CLM': {
      English: 'Conga (Apttus) CPQ CLM',
      Japanese:'Conga (Apttus) CPQ CLM',
    },
    'Salesforce cCRM': {
      English: 'Salesforce cCRM',
      Japanese: 'Salesforce cCRM',
    },
    'Health care - MP1 - Commercial': {
      English: 'Health care - MP1 - Commercial',
      Japanese: 'Health care - MP1 - コマーシャル',
    },
    'Health care imaging and ultrasound': {
      English: 'Health care imaging and ultrasound',
      Japanese: 'Health careイメージング and ウルトラサウンド',
    },
    'IT Portal': {
      English: 'IT Portal',
      Japanese: 'ITポータル',
    },
    'TrackWise': {
      English: 'TrackWise',
      Japanese: 'TrackWise',
    },
    'ServiceMax': {
      English: 'ServiceMax',
      Japanese: 'ServiceMax',
    },
    'Philips voice cloud' : {
      English: 'Philips voice cloud',
      Japanese: 'Philips 音声クラウド',
    },
    'Philips asset library': {
      English: 'Philips asset library',
      Japanese: 'Philips 資産ライブラリー',
    }, 
    'Philips product library': {
      English: 'Philips product library',
      Japanese: 'Philips製品ライブラリー',
    },
    'Azure DevOps': {
      English: 'Azure DevOps',
      Japanese: 'Azure DevOps',
    },
    'GitHub': {
      English: 'GitHub',
      Japanese: 'GitHub',
    },
    'Artifactory': {
      English: 'Artifactory',
      Japanese: 'Artifactory',
    },
    'SonarQube': {
      English: 'SonarQube',
      Japanese: 'SonarQube',
    },
    'CodeScene': {
      English: 'CodeScene',
      Japanese: 'CodeScene',
    },
    'Coverity': {
      English: 'Coverity',
      Japanese: 'Coverity',
    },
    'その他のアプリケーション': {
      English: 'その他のアプリケーション',
      Japanese: '他のアプリケーション',  // It is already in Japanese
    },
  };
  
  const serviceTranslations = {
    'Microsoft Teams Video room': {
      English: 'Microsoft Teams Video room',
      Japanese: 'Microsoft Teamsビデオルーム',  // Example translation for Japanese
    },
    'IT Service Desk': {
      English: 'IT Service Desk',
      Japanese: 'ITサービスデスク',
    },
    'Office network connectivity': {
      English: 'Office network connectivity',
      Japanese: 'オフィスネットワーク環境',
    },
    'Digital collaboration': {
      English: 'Digital collaboration',
      Japanese: 'デジタルコラボレーション',
    },
    'Mobile telephony service': {
      English: 'Mobile telephony service',
      Japanese: '携帯電話サービス',
    },
    'Philips IT cloud orchestration': {
      English: 'Philips IT cloud orchestration',
      Japanese: 'Philips ITクラウドオーケストレーション',
    },
    'Philips Personal Computer systems': {
      English: 'Philips Personal Computer systems',
      Japanese: 'Philipsパーソナルコンピューターシステム',
    },
    'IT Experience Center': {
      English: 'IT Experience Center',
      Japanese: 'IT Experience Center',
    },
  };

  const selectedLangText = {
    Japanese: {
      chooseFeedback: "フィードバックしたい内容を選択してください。",
      services: "サービス:",
      applications: "アプリケーション:",
      errorMessage: "おっと！問題が発生しました。戻ってもう一度やり直してください。",
    },
    English: {
      chooseFeedback: "Choose what you would like to share feedback on?",
      services: "Services:",
      applications: "Applications:",
      errorMessage: "Oops! Something went wrong. Please go back and try again.",
    }
  };

  const selectedLangTextToDisplay = selectedLangText[selectedLanguage] || selectedLangText['English'];

  const services = Object.keys(serviceTranslations); // List of services
  console.log('Original services (English):', services); // Console log for services
  const translatedServices = services.map(service => {
    const translatedService = serviceTranslations[service][selectedLanguage] || service;
    console.log(`Service: ${service} - Translated: ${translatedService}`); // Log for each service translation
    return translatedService;
  });
  

  // Filter applications based on the selected language and accessible ones
  const applications = questions[selectedLanguage]?.filter(
    (question) => !services.includes(question) && accessibleApplications.includes(question)
  ) || [];
  console.log('Filtered Applications:', applications); // Log for filtered applications

  const handleChange = (checkedValues) => {
    dispatch(setSelectedAnswers(checkedValues));
  };

  const handleSubmit = () => {
    // Pass the original English services to the next page
    navigate('/feedback', { state: { selectedAnswers, selectedLanguage, services: services } });
  };

  const translatedApplications = applications.map((app) => {
    const originalAppName = app;  // `app` is the English name
    const translatedAppName = applicationTranslations[originalAppName]?.[selectedLanguage] || originalAppName;
    console.log(`Application: ${app} - Translated: ${translatedAppName}`);  // Log for application translation
    return translatedAppName;  // Use the translated name or fallback to the original English name
  }).filter(Boolean);  // Remove any null or undefined values// Remove any null values if translation is not found

  return (
    <Layout>
      <Navbar />
      <Content>
        <Row style={{ minHeight: '94vh',borderTop: "1.3px solid rgba(128, 128, 128,0.5)", }} gutter={0}>
          {/* Sidebar */}
          <SurveyInfo />

          <Col
            className='second-col'
            span={18}
            style={{
              backgroundColor: 'white',
              padding: '25px',
              display: 'flex',
              flexDirection: 'column',
              borderLeft: "1.3px solid rgba(128, 128, 128,0.5)",
              ...(accessibleApplications.length === 0 && {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }),
            }}
          >
            {accessibleApplications.length ? (
              <>
                <h3>{selectedLangTextToDisplay.chooseFeedback}</h3>
                <h4 style={{ fontWeight: 'bold', marginBottom: '10px' }}>{selectedLangTextToDisplay.services}</h4>
                <Checkbox.Group value={selectedAnswers} onChange={handleChange}>
  <Row gutter={16}>
    {translatedServices.map((service, i) => (
      <Col xs={24} sm={12} md={6} key={i} style={{ marginBottom: 8 }}>
        {/* label becomes the child of Checkbox */}
        <Checkbox
          value={services[i]}
          className="custom-checkbox"
        >
          {service}
        </Checkbox>
      </Col>
    ))}

    <Col span={24}>
      <Divider style={{ borderColor: 'darkgray', borderWidth: '1px' }} />
      <h4 style={{ fontWeight: 'bold', marginBottom: '5px' }}>
        {selectedLangTextToDisplay.applications}
      </h4>
    </Col>

    {applications.map((origApp, i) => {
      const translatedApp = applicationTranslations[origApp]?.[selectedLanguage] || origApp;
      return (
        <Col xs={24} sm={12} md={6} key={i} style={{ marginBottom: 8 }}>
          <Checkbox
            value={origApp}
            className="custom-checkbox"
          >
            {translatedApp}
          </Checkbox>
        </Col>
      );
    })}
  </Row>
</Checkbox.Group>

                <Footer
                  onBack={() => navigate('/lang')}
                  onNext={handleSubmit}
                  nextDisabled={selectedAnswers.length === 0}
                />
              </>
            ) : (
              <>
                <h3>{selectedLangTextToDisplay.errorMessage}</h3>
                <Footer
                  onBack={() => navigate('/itux-happiness-survey')}
                  onNext={handleSubmit}
                  nextDisabled={true}
                />
              </>
            )}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default QuestionsPage;
